"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoadingState = getLoadingState;
exports.getItemInfo = getItemInfo;
exports.processSelectionChildren = processSelectionChildren;
exports.processActions = processActions;
exports.processOptions = processOptions;
exports.itemMatchesQuery = itemMatchesQuery;
exports.getSelected = getSelected;
exports.getActions = getActions;
exports.filterLoadMore = filterLoadMore;
exports.menuSizeProps = exports.statusProps = exports.sizeProps = exports.isNotDropdownItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _flag = _interopRequireDefault(require("../Flag/flag"));

var _subComponents = require("./subComponents/");

var _children = require("../helpers/children");

var _airbnbPropTypes = require("airbnb-prop-types");

var stateTypes = _interopRequireWildcard(require("../../constants/state.types"));

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getLoadingState(_ref) {
  var checked = _ref.checked,
      error = _ref.error,
      loading = _ref.loading;
  if (checked) return stateTypes.SUCCESS;
  if (error) return stateTypes.ERROR;
  if (loading) return stateTypes.LOADING;
}

function getItemInfo(item) {
  if (!item || !item.props) return;
  var _item$props = item.props,
      value = _item$props.value,
      name = _item$props.name;
  return {
    value: value,
    name: name
  };
}

function processSelectionChildren(children) {
  var child = Array.isArray(children) && typeof children[0] === 'string' ? children[0] : children;

  if (child && typeof child === 'string') {
    return _react.default.createElement(_subComponents.DropdownOptionContent, null, child);
  }

  return child;
}

function processItemDescription(optionContent, index) {
  var _optionContent$props = optionContent.props,
      description = _optionContent$props.description,
      children = _optionContent$props.children;
  return description ? [children, _react.default.createElement(_subComponents.DropdownOptionDescription, {
    key: index
  }, description)] : children;
}

function processListItems(children) {
  return _react.default.Children.toArray(children).map(function (optionContent, index) {
    if (!_react.default.isValidElement(optionContent)) return optionContent;
    return _react.default.cloneElement(optionContent, {
      noWrap: !!(0, _children.getFirstDirectChildOfTypes)(children, [_subComponents.DropdownOptionContent]),
      children: processItemDescription(optionContent, index)
    });
  });
}

function processItemIcon(children, withDescription, active) {
  var childrenArr = _react.default.Children.toArray(children);

  var hasOptionContent = !!(0, _children.getFirstDirectChildOfTypes)(children, [_subComponents.DropdownOptionContent]);
  var isIconOrFlag = _typeof(childrenArr[0]) === 'object' ? (0, _compareElementType.default)(childrenArr[0].props.children, _icon.default) || (0, _compareElementType.default)(childrenArr[0].props.children, _flag.default) : false;
  if (hasOptionContent && isIconOrFlag) return null;
  var iconName = active ? _icon.default.CHECK : _icon.default.EMPTY;
  return _react.default.createElement(_subComponents.DropdownOptionContent, {
    noWrap: true,
    minimal: true,
    alignTop: withDescription
  }, _react.default.createElement(_icon.default, {
    name: iconName
  }));
}

function processActions(actions, toggleMenu) {
  return _react.default.Children.map(actions, function (action, index) {
    var _action$props = action.props,
        children = _action$props.children,
        _onClick = _action$props.onClick,
        keepOpen = _action$props.keepOpen;
    return _react.default.createElement(_subComponents.DropdownAction, {
      onClick: function onClick(event) {
        if (!keepOpen) {
          toggleMenu();
        }

        _onClick(event);
      },
      key: index
    }, processListItems(children));
  });
}

function processOptions(children, isMulti) {
  return _react.default.Children.map(children, function (child) {
    if ((0, _compareElementType.default)(child, _subComponents.DropdownOptionGroup)) {
      return _react.default.createElement(_subComponents.DropdownOptionGroup, child.props, processOptions(child.props.children, isMulti));
    }

    return _react.default.Children.map(child, function (_ref2) {
      var props = _ref2.props;
      var children = props.children,
          selected = props.selected,
          withDescription = props.withDescription;
      var active = isMulti ? children.props.checked : selected;
      return _react.default.createElement(_subComponents.DropdownOption, _extends({
        active: active,
        withDescription: withDescription
      }, props), !isMulti ? processItemIcon(children, withDescription, active) : null, processListItems(children));
    });
  });
}

function itemMatchesQuery(name, query) {
  return !!(name && name.toLowerCase().includes(query));
}

function getSelected(children) {
  return _react.default.Children.map(children, function (child) {
    if ((0, _compareElementType.default)(child, _subComponents.DropdownOptionGroup)) return getSelected(child.props.children);
    if (!child.props.selected) return;
    return child;
  });
}

function getActions(children) {
  return _react.default.Children.map(children, function (child) {
    if ((0, _compareElementType.default)(child, _subComponents.DropdownActions)) {
      return child.props.children;
    }
  });
}

var isNotDropdownItem = function isNotDropdownItem(child) {
  return (0, _compareElementType.default)(child, _subComponents.DropdownActions) || (0, _compareElementType.default)(child, _subComponents.DropdownAction) || (0, _compareElementType.default)(child, _subComponents.DropdownLoadMore);
};

exports.isNotDropdownItem = isNotDropdownItem;

function filterLoadMore(children) {
  return _react.default.Children.map(children, function (child) {
    return (0, _compareElementType.default)(child, _subComponents.DropdownLoadMore) ? child : null;
  });
}

var sizeProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
exports.sizeProps = sizeProps;
var statusProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('loading', 'checked', 'error');
exports.statusProps = statusProps;
var menuSizeProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('smallMenu', 'largeMenu');
exports.menuSizeProps = menuSizeProps;
processSelectionChildren.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "processSelectionChildren"
};